import * as AddToBasket from '@ori-events/add-to-basket';
import * as LoyaltyDialogResult from '@ori-events/loyalty-dialog-result';
import * as ShowLoyaltyDialog from '@ori-events/show-loyalty-dialog';
import { useCallback, useEffect, useState } from 'react';

export const useLoyaltyDialog = () => {
  const [data, setData] = useState<ShowLoyaltyDialog.Data | undefined>();

  const handleLoyaltyDialogResult = useCallback(
    (result: LoyaltyDialogResult.Result) => {
      if (data) {
        const event = new CustomEvent<LoyaltyDialogResult.Data>(LoyaltyDialogResult.Name, {
          detail: {
            ...data,
            result,
          },
        });
        window.dispatchEvent(event);
        // unmountDialog
        setData(undefined);
      }
    },
    [data],
  );

  const handleClose = useCallback(
    () => handleLoyaltyDialogResult(LoyaltyDialogResult.LoyaltyDialogResults.CLOSE),
    [handleLoyaltyDialogResult],
  );

  const handleBuyForPoints = useCallback(
    () => handleLoyaltyDialogResult(AddToBasket.Method.BUY_FOR_POINTS),
    [handleLoyaltyDialogResult],
  );

  const handleBuyForMoney = useCallback(
    () => handleLoyaltyDialogResult(AddToBasket.Method.BUY_FOR_MONEY),
    [handleLoyaltyDialogResult],
  );

  useEffect(() => {
    const showLoyaltyDialogCallback = ((event: ShowLoyaltyDialog.Event) => {
      setData(event.detail);
    }) as EventListener;

    window.addEventListener(ShowLoyaltyDialog.Name, showLoyaltyDialogCallback);

    return () => window.removeEventListener(ShowLoyaltyDialog.Name, showLoyaltyDialogCallback);
  }, []);

  return {
    data,
    handleBuyForMoney,
    handleBuyForPoints,
    handleClose,
  };
};
